





































































































































import Vue from "vue";
import iwSectionWithIcon from "@/encoding/components/layout/SectionWithIcon.vue";
import iwBedroomCount from "./questions/interior/BedroomCount.vue";
import iwBathroomCount from "./questions/interior/BathroomCount.vue";
import iwShowerRoomCount from "./questions/interior/ShowerRoomCount.vue";
import iwToiletCount from "./questions/interior/ToiletCount.vue";
import iwFloorAreaKitchen from "./questions/interior/FloorAreaKitchen.vue";
import iwKitchenSetup from "./questions/interior/KitchenSetup.vue";
import iwHasCellar from "./questions/interior/HasCellar.vue";
import iwHasLaundryRoom from "./questions/interior/HasLaundryRoom.vue";
import iwHasDiningRoom from "./questions/interior/HasDiningRoom.vue";
import iwHasLivingRoom from "./questions/interior/HasLivingRoom.vue";
import iwHasAttic from "./questions/interior/HasAttic.vue";
import iwHasOffice from "./questions/interior/HasOffice.vue";
import iwHasWorkspace from "./questions/interior/HasWorkspace.vue";
import iwHasIntercom from "./questions/interior/HasIntercom.vue";
import iwHasCableTv from "./questions/interior/HasCableTv.vue";
import iwHasArmoredDoor from "./questions/interior/HasArmoredDoor.vue";
import iwHasSecurityAlarm from "./questions/interior/HasSecurityAlarm.vue";
import iwHasJacuzzi from "./questions/interior/HasJacuzzi.vue";
import iwHasSauna from "./questions/interior/HasSauna.vue";
import iwHasFireplace from "./questions/interior/HasFireplace.vue";
import iwAmountAccessDoor from "./questions/interior/AmountAccessDoor.vue";
import iwAmountSectionalDoor from "./questions/interior/AmountSectionalDoor.vue";
import iwAmountSlidingDoor from "./questions/interior/AmountSlidingDoor.vue";
import iwAmountLoadingBays from "./questions/interior/AmountLoadingBays.vue";
import iwAmountCoveredBays from "./questions/interior/AmountCoveredBays.vue";
import iwAmountDockLevel from "./questions/interior/AmountDockLevel.vue";
import iwMinAvailableHeight from "./questions/interior/MinAvailableHeight.vue";
import iwMaxAvailableHeight from "./questions/interior/MaxAvailableHeight.vue";
import iwShopWindowWidth from "./questions/interior/ShopWindowWidth.vue";
import iwFloorAreaShowroom from "./questions/interior/FloorAreaShowroom.vue";
import iwFloorAreaEntreprise from "./questions/interior/FloorAreaEntreprise.vue";
import iwHasReceptionDesk from "./questions/interior/HasReceptionDesk.vue";
import iwInternalFixtures from "@/encoding/pages/questions/interior/InternalFixtures.vue";
import iwMiscellaneousFixtures from "@/encoding/pages/questions/interior/MiscellaneousFixtures.vue";
import iwHasInternet from "@/encoding/pages/questions/interior/HasInternet.vue";
import iwHasVisiophone from "@/encoding/pages/questions/interior/HasVisiophone.vue";
import iwNumberOfRooms from "@/encoding/pages/questions/interior/NumberOfRooms.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { mapActions, mapState } from "vuex";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";

export default Vue.extend({
    components: {
        iwSectionWithIcon: iwSectionWithIcon,
        iwInternalFixtures: iwInternalFixtures,
        iwMiscellaneousFixtures: iwMiscellaneousFixtures,
        iwBedroomCount: iwBedroomCount,
        iwBathroomCount: iwBathroomCount,
        iwShowerRoomCount: iwShowerRoomCount,
        iwToiletCount: iwToiletCount,
        iwFloorAreaKitchen: iwFloorAreaKitchen,
        iwKitchenSetup: iwKitchenSetup,
        iwHasCellar: iwHasCellar,
        iwHasLivingRoom: iwHasLivingRoom,
        iwHasDiningRoom: iwHasDiningRoom,
        iwHasLaundryRoom: iwHasLaundryRoom,
        iwHasAttic: iwHasAttic,
        iwHasOffice: iwHasOffice,
        iwHasWorkspace: iwHasWorkspace,
        iwHasIntercom: iwHasIntercom,
        iwHasCableTv: iwHasCableTv,
        iwHasArmoredDoor: iwHasArmoredDoor,
        iwHasSecurityAlarm: iwHasSecurityAlarm,
        iwHasJacuzzi: iwHasJacuzzi,
        iwHasSauna: iwHasSauna,
        iwHasFireplace: iwHasFireplace,
        iwAmountAccessDoor: iwAmountAccessDoor,
        iwAmountSectionalDoor: iwAmountSectionalDoor,
        iwAmountSlidingDoor: iwAmountSlidingDoor,
        iwAmountLoadingBays: iwAmountLoadingBays,
        iwAmountCoveredBays: iwAmountCoveredBays,
        iwAmountDockLevel: iwAmountDockLevel,
        iwMinAvailableHeight: iwMinAvailableHeight,
        iwMaxAvailableHeight: iwMaxAvailableHeight,
        iwShopWindowWidth: iwShopWindowWidth,
        iwFloorAreaShowroom: iwFloorAreaShowroom,
        iwFloorAreaEntreprise: iwFloorAreaEntreprise,
        iwHasReceptionDesk: iwHasReceptionDesk,
        iwHasInternet: iwHasInternet,
        iwHasVisiophone: iwHasVisiophone,
        iwNumberOfRooms: iwNumberOfRooms,
        iwNextPreviousButton: iwNextPreviousButton
    },

    data: function() {
        return {
            isButtonDisabled: false as boolean
        };
    },

    computed: {
        ...mapState("FormModule", ["isEditionMode"]),
        hasBedroom: function(): boolean {
            return ["HOUSE", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasKitchen: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","HOMES_TO_BUILD","OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasBathroom: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        },
        hasOtherRooms: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","OTHER", "HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasNumberOfRooms: function(): boolean {
            return ["HOUSE", "APARTMENT", "OTHER","HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        }
    },
    mounted: function() {
        pushPageViewEvent("classified_deposit_step6_interior_info");
    },

    methods: {
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        clickNext: function(){
            this.isButtonDisabled = true;
            if (this.isEditionMode){
                validationClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            } else {
                this.isButtonDisabled = true;
                updateClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            }
        },
        clickPrevious: function(){
            this.goToPreviousStep();
        }
    }

});
